import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `breadCrumbsWidget` presents an horizontal list of pages the user
 * can go to, with the right-most item representing the current
 * page. Usually, a breadcrumb is used when the user is invited to
 * navigate down a tree of pages.
 *
 * @param {Array} [spec.items] - The objects this should be rendered
 * as part of the breadcrumb. Any kind of object will do.
 * @param {Renderer} [spec.getLabel] - Function which takes an item as
 * parameter and returns a renderable.
 * @param {string} [spec.cssClass] - This class will be added to the
 * main DOM element.
 */
export default class BreadCrumbsWidget extends Widget {
	constructor({ items = [], getLabel = (item) => item, cssClass = "" }) {
		super(...arguments);

		this._items = items || [];
		this._onClick = () => {};
		this._getLabel = getLabel;
		this._cssClass = cssClass;
	}

	setItems(newItems) {
		this._items = newItems;
	}

	onClick(callback) {
		this._onClick = callback;
	}

	renderContentOn(html) {
		html.ul(
			{ klass: ["breadcrumb", this._cssClass] },
			this._itemsRenderer(this._items),
		);
	}

	_itemsRenderer(items) {
		const size = this._items.length;

		return items.map((item, index) => {
			if (index === size - 1) {
				return this._activeItemRenderer(item);
			}
			return this._inactiveItemRenderer(item);
		});
	}

	_activeItemRenderer(item) {
		return (html) => html.li({ klass: "active" }, this._getLabel(item));
	}

	_inactiveItemRenderer(item) {
		return (html) =>
			html.li(
				html.a(this._getLabel(item)).click(() => this._onClick(item)),
			);
	}
}
